import { render, staticRenderFns } from "./UgiButton.vue?vue&type=template&id=0afa328f&scoped=true&"
import script from "./UgiButton.vue?vue&type=script&lang=js&"
export * from "./UgiButton.vue?vue&type=script&lang=js&"
import style0 from "./UgiButton.vue?vue&type=style&index=0&id=0afa328f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa328f",
  null
  
)

export default component.exports